import { Slice as BreadcrumbsItemsSlice } from "./redux/Slice";

export { BreadcrumbsItemsSlice };
